<template>
    <div class="tooltip-block">
        <i class="uk-close" @click=closeToolTip></i>
        <shestirenkaLoader v-if=loading />
        <div v-if="indexData" class="tooltip-block-content">
            <div class="tooltip-block-title">
                <card-link v-if="indexData.ogrn" :ogrn="indexData.ogrn">{{indexData.name_short || indexData.name_full}}</card-link>
                <template v-else>
                    <template v-if="indexData.name_short">{{indexData.name_short}}</template>
                    <template v-else>{{indexData.name_full}}</template>
                </template>
            </div>
            <div class="tooltip-block-ogrn-inn">
                <b>ИНН</b>: {{indexData.inn}} <b>ОГРН</b>: {{indexData.ogrn}}
            </div>

            <div class="tooltip-block-date">
                <template v-if="indexData.date_stop">
                    <i style="color: #e74c3c; cursor: help;" title="Ликвидированно" class="uk-icon-times-circle"></i>
                    <template> <i>ликвидированно:</i> {{new Date(indexData.date_stop).toLocaleDateString()}}</template>
                </template>
                <template v-else>
                    <i style="color: #2ecc71; cursor: help;" title="Действующее" class="uk-icon-check-circle"></i>
                    <template> <i>зарегистрировано:</i> {{new Date(indexData.date_start).toLocaleDateString()}}</template>
                </template>
            </div>
            <div class="tooltip-block-address" v-if="indexData.addr_full">
                <b>Адрес:</b> {{indexData.addr_full}}
            </div>
            <div class="tooltip-block-upr" v-if="indexData.upr[0] && indexData.upr.length && indexData.upr[0].position">
                <b>{{lowerButFirst(indexData.upr[0].position)}}:</b>
                <person-afil
                    class="stay-on-this-row"
                    v-if="indexData.upr[0].inn"
                    :fio="indexData.upr[0].name"
                    :inn="indexData.upr[0].inn"
                >
                    {{ correctFio(indexData.upr[0].name) + ` (ИНН ${indexData.upr[0].inn})` }}
                </person-afil>
                <span v-else>{{ correctFio(indexData.upr[0].name) }}</span>
            </div>
            <div v-else-if="indexData.upr[0]">
                <b>Управляющая компания:</b>
                <card-link v-if="indexData.upr[0].ogrn || indexData.upr[0].inn" :ogrn="indexData.upr[0].ogrn || indexData.upr[0].inn">
                    {{indexData.upr[0].name}} <span v-if="indexData.upr[0].inn">(ИНН {{indexData.upr[0].inn}})</span>
                </card-link>
                <span v-else-if="indexData.upr[0].name">{{indexData.upr[0].name}}</span>
                <span v-else>-</span>
            </div>
            <div class="tooltip-block-uchr">
                <b>Собственники: </b>
                <template v-if="indexData.uchr && indexData.uchr.length">
                    <span v-for="(e, i) in indexData.uchr" :key="i">
                        <card-link v-if="e.ogrn || (String(e.inn).length === 10)" :ogrn="e.ogrn || e.inn">{{ e.name }}<span v-if="e.inn">{{ ` (ИНН ${e.inn})` }}</span></card-link>
                        <person-afil class="stay-on-this-row" v-else-if="e.inn" :inn="e.inn" :fio="e.name">{{capitalizeButFirst(e.name)}} (ИНН {{e.inn}})</person-afil>
                        <template v-else>{{e.name}}<span v-if="e.inn">{{ ` (ИНН ${e.inn})` }}</span></template>
                        <template v-if="i != indexData.uchr.length - 1">, </template>
                    </span>
                </template>
                <template v-else>-</template>
            </div>
            <div class="tooltip-block-okved" v-if="indexData.okved_title">
                <b>ОКВЭД:</b> {{indexData.okved_title}}
            </div>
            <div class="tooltip-block-capital" v-if="indexData.auth_capital">
                <b>Уставный капитал:</b> {{moneyFormat(indexData.auth_capital)}} руб.
            </div>
            <div class="tooltip-block-viruchka" v-if="indexData.fin_years && indexData.fin_years.length && indexData.viruchka">
                <b>Выручка за {{indexData.fin_years[indexData.fin_years.length - 1]}} год:</b>
                <template>{{moneyFormat(indexData.viruchka)}}</template>
            </div>
        </div>
    </div>
</template>

<script>
import shestirenkaLoader from '@/components/ui/shestirenkaLoader.vue'
import cardLink from '@/components/ui/cardLink.vue'

import { capitalizeButFirst, correctFio, lowerButFirst } from '@/helpers.ts'


export default {
    components: {
        shestirenkaLoader,
        cardLink
    },
    props: ['indexData', 'closeToolTip', 'loading']
}
</script>

<style lang="sass" scoped>
@use 'styles/mobile.sass'

.tooltip-block
    position: absolute
    z-index: 200
    background: #f5f5f5
    width: 350px
    box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.5)
    padding: 15px
    border: 1px #c5c5c5 solid
    border-radius: 4px
    color: black
    font-size: 12px
    font-weight: 400
    @media screen and (max-width: 480px)
        position: fixed
        top: 170px
        left: 10px
        width: calc(100% - 20px)
    &-title
        font-weight: 700
        font-size: 14px
    .uk-close
        display: inline-block
        position: absolute
        right: 10px
        top: 10px
        font-size: 25px
    &-content
        display: flex
        flex-direction: column
        gap: 5px
    &-ogrn-inn
        font-style: italic
    &-date
        i
            font-style: italic

.stay-on-this-row
    display: inline
</style>